
import { Component, Vue } from 'vue-property-decorator';
import { store, StoreMutations, StoreActions, ApplicationState } from '@/store';

@Component
export default class Login extends Vue {

  public username = '';
  public password = '';

  get loading () {
      return store.state.loading;
  }

  async login() : Promise<void> {
    var loggedin = await store.dispatch(StoreActions.Login, { username: this.username, password: this.password });

    if(loggedin) {
      this.$router.push('/');
    } else {
      store.commit(StoreMutations.SetMessaggiErrore, ['Errore login. Verificare credenziali e riprovare.']);
    }
  }
}

